<template>
    <div class="offscreen-chart">
        <span class="offscreen-chart-title">{{ title }}</span>
        <div class="offscreen-chart-subtitle">
            <slot name="subtitle"></slot>
        </div>
        <slot name="chart"></slot>
        <div class="offscreen-chart-context">
            <slot name="context"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "OffscreenChart",
    props: {
        title: { type: String, default: null },
        // context: { type: Object, default: () => { return {} } }
    }
}
</script>

<style scoped>
    .offscreen-chart {
        overflow: hidden;
        width: 0;
        height: 0
    }
</style>